// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__3g8Nu","loaderOuter":"PageOverlayLoader_loaderOuter__10rTk"};